// Should probably save the profile pics onto the server instead of passing URLs from wordpress

export const useAdvisorProfilePic = (repName: string) => {
  const baseURL = 'https://azzadasset.com/wp-content/uploads/2025/01/Azzad-Asset-Management-'

  const map: Record<string, { slug: string; ext?: string }> = {
    'Bashar Qasem': { slug: 'Bashar-Qasemi', ext: 'webp' },
    'Joshua Brockwell': { slug: 'Joshua-Brockwell', ext: 'webp' },
    'Fatima Iqbal': { slug: 'Fatima-Iqbal', ext: 'png' },
    'Ehab Alalfey': { slug: 'Ehab-Alalfey', ext: 'webp' },
    'Ayman Khalil': { slug: 'Ayman-Khalil', ext: 'webp' },
    'Samer Eshmawy': { slug: 'Samer-Eshmawy', ext: 'webp' },
    'Deborah Klein': { slug: 'Deborah-Klein', ext: 'webp' },
    'Atta Khan': { slug: 'Atta-Khan', ext: 'webp' },
    'Tameem-Qasem': { slug: 'Tameem-Qasem', ext: 'webp' }
  }

  const entry = map[repName]
  if (!entry) return '' // or a default image

  return `${baseURL}${entry.slug}.${entry.ext ?? 'webp'}`
}
